import * as THREE from "three";
import GUI from "lil-gui";
import vertex from "./shaders/carousel/vertex.glsl";
import fragment from "./shaders/carousel/fragment.glsl";
import Lenis from "lenis";

const lenis = new Lenis({
  autoRaf: true,
  infinite: true,
  syncTouch: true,
});
let scrollFactor = 0;
let virtualScroll = 0;
lenis.on("scroll", (e) => {
  virtualScroll += e.velocity;
});

/**
 * Base
 */
// Debug

// Canvas
const canvas = document.querySelector("canvas.webgl");
/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

// Scene
const scene = new THREE.Scene();
/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.x = 0;
camera.position.y = 0;
camera.position.z = 3;
scene.add(camera);

const planes = [];
const videoEl = Array.from(document.querySelectorAll("video"));
const PlaneGeometry = new THREE.PlaneGeometry(16, 9, 32, 32);
const radius =
  (PlaneGeometry.parameters.width * videoEl.length * 2) / (Math.PI * 2) + 0.4;
for (let i = 0; i < videoEl.length * 2; i++) {
  const currentVideo = videoEl[i % videoEl.length];
  const texture = new THREE.VideoTexture(currentVideo);

  const angle = i * ((Math.PI * 2) / (videoEl.length * 2));

  const plane = new THREE.Mesh(
    PlaneGeometry,
    new THREE.ShaderMaterial({
      uniforms: {
        uTexture: { value: texture },
        uCount: { value: videoEl.length },
        uRadius: { value: radius },
        uAngle: { value: angle },
        uAlpha: { value: 0.5 },
      },
      vertexShader: vertex,
      fragmentShader: fragment,
      side: THREE.DoubleSide,
    })
  );
  scene.add(plane);

  plane.position.x = Math.cos(angle) * radius;
  plane.position.z = Math.sin(angle) * radius;

  plane.lookAt(0, 0, 0);
  plane.userData.angle = angle;
  plane.userData.isHovered = false;
  planes.push(plane);
}

const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();
window.addEventListener("mousemove", (event) => {
  // Convert mouse position to normalized device coordinates (-1 to +1)
  mouse.x = (event.clientX / sizes.width) * 2 - 1;
  mouse.y = -(event.clientY / sizes.height) * 2 + 1;

  const maxRotation = 0.1; // environ 6 degrés max
  targetCameraRotationY = mouse.x * maxRotation;
  targetCameraRotationX = mouse.y * maxRotation;
});

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

// Controls

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();

let targetCameraRotationX = 0;
let targetCameraRotationY = 0;
let cameraRotationX = 0;
let cameraRotationY = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  scrollFactor += virtualScroll * 0.0003; // ← À ajuster selon la sensibilité voulue
  virtualScroll *= 0.9;

  planes.forEach((plane) => {
    plane.userData.isHovered = false;
  });
  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObjects(planes);
  if (intersects.length > 0) {
    for (let i = 0; i < intersects.length; i++) {
      intersects[i].object.userData.isHovered = true;
    }
  }

  planes.forEach((plane) => {
    const angle = plane.userData.angle + scrollFactor;

    plane.position.x = Math.cos(angle) * radius;
    plane.position.z = Math.sin(angle) * radius;

    plane.lookAt(0, 0, 0);

    // Tu peux aussi mettre à jour l'uniforme uAngle si tu veux en faire qqch dans ton vertex shader :
    plane.material.uniforms.uAngle.value = angle;

    //Alpha
    const current = plane.material.uniforms.uAlpha.value;
    const target = plane.userData.isHovered ? 1 : 0.5;
    plane.material.uniforms.uAlpha.value = THREE.MathUtils.lerp(
      current,
      target,
      0.5
    );
  });

  // Update controls
  // Lissage du mouvement de la caméra (inertie)
  cameraRotationX = THREE.MathUtils.lerp(
    cameraRotationX,
    targetCameraRotationX,
    0.05
  );
  cameraRotationY = THREE.MathUtils.lerp(
    cameraRotationY,
    targetCameraRotationY,
    0.05
  );

  // Appliquer la rotation à la caméra
  camera.rotation.x = cameraRotationX;
  camera.rotation.y = cameraRotationY;

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();

const buttons = document.querySelectorAll(".btn");
buttons.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    if (e.target.classList.contains("concave")) {
      camera.position.z = 0;
    } else {
      camera.position.z = 40;
    }
  });
});
